/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
import { Injectable } from "@angular/core";
import { TranslateService } from "@html-core";
import { Localize } from "../../../shared/common/service/localize.service";

@Injectable()
export class HTML5TranslateService extends TranslateService {
   constructor(private localize: Localize) {
      super();
   }

   public _T = (...args: any[]) => {
      return this.localize.translate(...args);
   };
}
